<div class="modal">
  <div class="modal__login">
    <div>
      <div class="vault__logo">
        <img src="/assets/images/vault.jpg" alt="PLAY Vault" width="150" />
      </div>
      <div class="vault__title">
        {{ "forms.walletPassword" | translate }}
      </div>
      <div class="vault__notice">
        <div class="vault__notice-title">
          <img src="assets/images/warning.png" />
          <h6>Important Notice</h6>
        </div>
        <div class="vault__notice-info">
          <p>Your vault password cannot be changed or reset.</p>
          <ul>
            <li>Write it down and store it securely.</li>
            <li>
              If you forget or lose your password you will not be able to sell
              or trade your NFTs.
            </li>
            <li>
              Your NFTs will still be usable in-game as long as you have access
              to your PLAY account.
            </li>
          </ul>
          <p>
            By proceeding, you acknowledge that you have read and understood
            this warning.
          </p>
        </div>
      </div>
    </div>

    <div class="modal__login-form-column">
      <div class="modal__login-form form">
        <form [formGroup]="form" (ngSubmit)="createWallet()">
          <div class="form__item">
            <div class="form__field">
              <i class="icon-key form__item-icon"></i>
              <input
                formControlName="password"
                autocomplete="off"
                placeholder="{{ 'forms.password' | translate }}"
                [type]="passwordVisible ? 'text' : 'password'"
              />
              <i
                class="form__item-icon pw"
                [ngClass]="[passwordVisible ? 'icon-eye-off' : 'icon-eye']"
                (click)="passwordVisible = !passwordVisible"
              ></i>
            </div>
            <div
              class="form__field-error"
              *ngIf="showFieldErrs(form, 'password')"
            >
              {{ "forms.passwordRequired" | translate }}
            </div>
          </div>

          <div class="form__item">
            <div class="form__field">
              <i class="icon-key form__item-icon"></i>
              <input
                formControlName="passwordConfirm"
                autocomplete="off"
                placeholder="{{ 'forms.reenterPassword' | translate }}"
                [type]="passwordVisible ? 'text' : 'password'"
              />
              <i
                class="form__item-icon pw"
                [ngClass]="[passwordVisible ? 'icon-eye-off' : 'icon-eye']"
                (click)="passwordVisible = !passwordVisible"
              ></i>
            </div>
            <div class="form__field-error" *ngIf="showFormErrs(form)">
              {{ "forms.passwordsMismatch" | translate }}
            </div>
          </div>

          <div class="form__item form__item-submit">
            <button type="submit" [disabled]="form.invalid || form.disabled">
              {{ "forms.createWallet" | translate }}
              <i class="icon-arrow-right"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <a (click)="skipWalletCreation()" class="redirect"> Do it later </a>
  </div>
</div>
